class SearchSpring extends HTMLElement {
    constructor() {
        super();

        this._selectors = {
            productContainer: '[js-product-container]'
        }
    }
    connectedCallback() {
        this._fetchSearchAPI()
    }

    _fetchSearchAPI() {
        const tags = this.dataset.tags
        const sku = this.dataset.sku
        const limit = Number(this.dataset.limit)
        const customerId = this.dataset.customerId
        const options = {method: 'GET', headers: {accept: 'application/json'}};
        let url = `https://hlq244.a.searchspring.io/boost/hlq244/recommend?tags=${tags}&product=${sku}&limits=${limit}&shopper=${customerId}`

        fetch(url, options)
          .then(response => response.json())
          .then(response => {
            console.log('response', response)
            const searchSpringProductContainer = this.querySelector(this._selectors.productContainer)
            if (response[0].results.length) {
                for (let i = 0; i < response[0].results.length; i++) {
                    const productCard = this._createProductCard(response[0].results[i])
                    searchSpringProductContainer.appendChild(productCard)
                }
            } else {
                searchSpringProductContainer.textContent = 'No recommendations'
            }

          })
          .catch(err => console.error(err));
    }

    _createProductCard(product) {
        const productUrl = product.mappings.core.url
        const productTitle = product.mappings.core.name
        const productImageUrl = product.attributes.ss_image
        const productHoverImageUrl = product.attributes.ss_image_hover
        const productPrice = product.mappings.core.price
        const productMsrp = product.mappings.core.msrp

        // Creating Element Components

        const productCardContainer = document.createElement("a")
        productCardContainer.setAttribute('href', productUrl)
        productCardContainer.classList.add('product-card')
        productCardContainer.classList.add('swiper-slide')
        productCardContainer.classList.add('aos-init')
        productCardContainer.classList.add('aos-animate')
        productCardContainer.classList.add('product-card__link')
        
        const productCardImage = document.createElement("img")
        productCardImage.setAttribute('src', productImageUrl )
        productCardImage.setAttribute('alt', productTitle)
        productCardImage.classList.add('ss-product-card__img')

        const productCardHoverImage = document.createElement('img')
        productCardHoverImage.setAttribute('src', productHoverImageUrl )
        productCardHoverImage.classList.add('ss-product-card__img-hover')

        const productCardTitle = document.createElement("div")
        productCardTitle.textContent = productTitle
        productCardTitle.classList.add('product-card__title')

        const productCardPrice = document.createElement("div")
        productCardPrice.classList.add('price-card__price-container')
        const productCardPriceSpan = document.createElement("p")
        const price = Number(productPrice) * 100
        productCardPriceSpan.textContent = this.formatMoney(price)
        productCardPriceSpan.classList.add('price')
        productCardPrice.appendChild(productCardPriceSpan)

        if (productMsrp) {
            const productCardOriginalPrice = document.createElement('s')
            const originalPrice =  Number(productMsrp) * 100
            productCardOriginalPrice.textContent = this.formatMoney(originalPrice)
            productCardOriginalPrice.classList.add('price')
            productCardOriginalPrice.classList.add('price--sale')
            productCardPrice.appendChild(productCardOriginalPrice)
        }
        const productCardTextContainer = document.createElement("div")
        productCardTextContainer.classList.add('product-card__details')

        // Assembling Components
        productCardContainer.appendChild(productCardImage)
        productCardContainer.appendChild(productCardHoverImage)
        productCardContainer.appendChild(productCardTextContainer)
        productCardTextContainer.appendChild(productCardTitle)
        productCardTextContainer.appendChild(productCardPrice)

        return productCardContainer
    }

    formatMoney(cents) {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          });
        return formatter.format(cents * .01)
    }
}
customElements.define("s-searchspring", SearchSpring);